import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useAlarmJournalQuery(options) {
  var queryApi = useDeviceQueryApi();
  return queryApi.useAlarmJournalQuery(options);
}